import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'We need your consent before we can make this payment',
    id: 'ConsentDisclaimer.header',
  },
});
